// 숫자 Validation
function validateNumber(value) {
    if (validateSpace) {
        // 공백이 없으면
        const numReg = /^[0-9]*$/;
        return numReg.test(String(value)); // 숫자 체크
    }
    return false;
}

// 이메일 Validation
function validateEmail(value) {
    if (validateSpace) {
        // 공백이 없으면
        const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // const emailReg =
        //     /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
        return emailReg.test(String(value)); // 이메일형식 체크
    }
    return false;
}

// 공백 Validation
function validateSpace(value) {
    const spaceReg = /\s/g;
    return !value.match(spaceReg);
}

// 사업자번호 Validation
function validateBizNo(value) {
    if (validateSpace) {
        const bizNoReg = /^[0-9]{10}$/;
        return bizNoReg.test(String(value));
    }
}

// 전화번호 Validation
function validateTelNo(value) {
    if (validateSpace) {
        const telNoReg = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})?[0-9]{3,4}?[0-9]{4}$/;
        return telNoReg.test(String(value));
    }
}

// 전화번호 Validation
function validateFormattedTelNo(value) {
    if (validateSpace) {
        const telNoReg = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-[0-9]{3,4}-[0-9]{4}$/;
        return telNoReg.test(String(value));
    }
}

// 최근 게시글(N) 표시 위한 날짜 계산, true면 새 게시글 (7일이 지나지 않은 게시글))
function calcNewPost(value) {
    const today = new Date();
    const before7Days = new Date(today.setDate(today.getDate() - 7));

    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    if (before7Days < new Date(Date.UTC(...b))) {
        return true;
    }
    return false;
}

export {
    validateNumber,
    validateEmail,
    validateSpace,
    validateBizNo,
    validateTelNo,
    validateFormattedTelNo,
    calcNewPost,
};
